import styled from '@emotion/styled';

import { ModalTitle } from 'components/global/styled/Modal.styled';

import { Breakpoints } from 'utils/const.styles';

export const StyledModalTitle = styled(ModalTitle)`
	width: 100%;

	@media ${Breakpoints.mobileLandscape} {
		.progressWizard {
			padding: 2rem 0 0 0;
		}
	}

	@media ${Breakpoints.mobile} {
		.progressWizard {
			padding: var(--padding-4) var(--padding-3);
		}
	}
`;
